import ActivityIcon from "@Components/activity/ActivityIcon";
import { IActivityDetails } from "@Models/IActivityDetails";
import { getActivityLabel } from "@Utils";
import moment from "moment";
import React from "react";

interface IProps {
    activity: IActivityDetails;
}

const ActivityTabTitle: React.FC<IProps> = ({ activity }) => (
    <div className="activity-title flex">
        <ActivityIcon categoryName={activity?.categoryName} size={24} />
        <span className={"title"}>{getActivityLabel(activity)}</span>
        <span className={"date"}>{moment(activity?.creationDate).format("ddd, MMM Do YYYY, h:mm a")}</span>
    </div>
);

export default ActivityTabTitle;
